import { ButtonLink } from "~/components/ui/button";

interface BreakdownIntroProps {
  breakdownName: string;
  breakdownTypeSlug: string;
  introTextLine1?: string;
  introTextLine2?: string;
  ctaButtonTextTemplate: string;
  utmCampaignPrefix: string; // e.g., 'category_coaches' or 'city_coaches'
}

export const BreakdownIntro = ({
  breakdownName,
  breakdownTypeSlug,
  introTextLine1,
  introTextLine2,
  ctaButtonTextTemplate,
  utmCampaignPrefix,
}: BreakdownIntroProps) => {
  const ctaText = ctaButtonTextTemplate.replace("{}", breakdownName);

  return (
    <>
      {introTextLine1 && (
        <div className="mx-auto prose prose-lg mt-6 text-center">
          <p>{introTextLine1}</p>
          {introTextLine2 && <p>{introTextLine2}</p>}
        </div>
      )}
      <div className="mt-8 flex items-center justify-center">
        <ButtonLink
          variant="primary"
          href={`/discovery?utm_campaign=${utmCampaignPrefix}&utm_source=${breakdownTypeSlug}`}
          target="_blank"
          className="text-center"
        >
          {ctaText}
        </ButtonLink>
      </div>
    </>
  );
};
